module.exports = __webpack_public_path__ + "img/dichengben.5bbd1cd7.png";